import styled, { css } from "styled-components";

export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    > label {
        margin: 0;
    }
`;

export const Icon = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;

    transition: 250ms all ease-in-out;

    svg {
        width: 20px;
        height: 20px;
    }
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    svg {
        width: 20px;
        height: 20px;
    }
`;

export const OptionStyled = styled.div`
    position: relative;
    z-index: 1;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: 10px;
    padding: 20px;

    background-color: var(--color-athensGrey);
    border: 1px solid rgba(0, 23, 75, 0.1);

    transition: 250ms all ease-in-out;

    ${({ open }) =>
        open &&
        css`
            background-color: var(--color-white);

            ${Icon} {
                svg {
                    transform: rotateX(180deg);
                }
            }
        `}

    ${({ active }) =>
        active &&
        css`
            background-color: var(--color-white);
        `}
`;

export const Text = styled.div`
    margin: 0 20px;

    text-align: left;
`;

export const Info = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`;

export const Value = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 0;
    overflow: hidden;

    visibility: hidden;
    opacity: 0;

    transition: 250ms all ease-in-out;

    ${({ active }) =>
        active &&
        css`
            margin-top: 20px;
            height: auto;

            visibility: visible;
            opacity: 1;
        `};
`;
